/* eslint-disable global-require */
import { WORKSPACES_URL } from '../config/urls';
import { FETCH_WORKSPACE_PROJECTS } from './types';
import { catchNotAllowedResponseWrapper as baseCatchNotAllowedResponseWrapper } from '../lib/catchNotAllowedResponseWrapper';

// Lazy import to break circular dependency with catchNotAllowedResponseWrapper.js
const catchNotAllowedResponseWrapper = ( promise, dispatch, workspaceID ) => {
	const { fetchCurrentUserWorkspaces } = require( './workspaces' );
	return baseCatchNotAllowedResponseWrapper( promise, dispatch, workspaceID, fetchCurrentUserWorkspaces );
};

export const fetchWorkspaceProjects = workspaceID => ( dispatch, _, api ) => dispatch( {
	type: FETCH_WORKSPACE_PROJECTS,
	promise: catchNotAllowedResponseWrapper( api.get(
		`${WORKSPACES_URL}/${workspaceID}/projects` ), dispatch, workspaceID )
		.then( response => response.response ),
	meta: { workspaceID }
} );
